import FilterableCell, { getRefId, resolveRef } from '@/widgets/FilterableCell'

export default function MiastoTableRow({
	miasto,
	onGminaFilter,
	onPowiatFilter,
	onWojewodztwoFilter,
	onNazwaClick,
}) {
	const miastoId = getRefId(miasto)
	const gmina = resolveRef(miasto?.id_gmina)
	const powiat = resolveRef(miasto?.id_powiat)
	const wojewodztwo = resolveRef(miasto?.id_wojewodztwo, miasto?.id_powiat?.id_wojewodztwo)

	return (
		<tr className="hover:bg-gray-100">
			<td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
				<FilterableCell
					id={miastoId}
					label={miasto?.nazwa || '-'}
					onFilter={onNazwaClick}
				/>
			</td>
			<td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
				<FilterableCell id={gmina.id} label={gmina.label} onFilter={onGminaFilter} />
			</td>
			<td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
				<FilterableCell id={powiat.id} label={powiat.label} onFilter={onPowiatFilter} />
			</td>
			<td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
				<FilterableCell
					id={wojewodztwo.id}
					label={wojewodztwo.label}
					onFilter={onWojewodztwoFilter}
				/>
			</td>
		</tr>
	)
}
